// extracted by mini-css-extract-plugin
export default {"devider":"Password_devider__da2JW","brandHead":"Password_brandHead__+trYq","tabHead":"Password_tabHead__dc0Xd","resetOption":"Password_resetOption__3pOE6"};